import apiClient, { extractData } from "./client";

export async function submitResignation(data) {
  const response = await apiClient.post("/resignation", data);
  return extractData(response);
}

export async function getMyResignation() {
  const response = await apiClient.get("/resignation/my");
  return extractData(response);
}

export async function withdrawResignation() {
  const response = await apiClient.delete("/resignation/my/withdraw");
  return extractData(response);
}

export async function listResignations() {
  const response = await apiClient.get("/resignation");
  return extractData(response);
}

export async function getResignation(id) {
  const response = await apiClient.get(`/resignation/${id}`);
  return extractData(response);
}

export async function approveResignation(id, data = {}) {
  const response = await apiClient.post(`/resignation/${id}/approve`, data);
  return extractData(response);
}

export async function rejectResignation(id, data = {}) {
  const response = await apiClient.post(`/resignation/${id}/reject`, data);
  return extractData(response);
}
